<template>
  <div class="page_table_box">
    <div class="school_table_box">
      <el-table
        :data="tableData"
        height="100%"
        class="table_box content-box"
        :border="true"
        :span-method="arraySpanMethod"
        :header-cell-style="{ background: '#E2EEFF', color: '#474859' }"
      >
        <el-table-column
          prop="rid"
          label="序号"
          align="center"
        ></el-table-column>
        <el-table-column prop="inspectTarget" label="检查项目" align="center">
        </el-table-column>
        <el-table-column prop="standard" label="标准" align="center">
        </el-table-column>
        <el-table-column
          prop="faultType"
          label="不符合标准情况及后果"
          align="center"
        >
        </el-table-column>
        <el-table-column
          prop="existingMeasures"
          label="现有管控措施"
          align="center"
        >
        </el-table-column>
        <el-table-column prop="lsL" label="L" align="center" width="80">
        </el-table-column>
        <el-table-column prop="lsS" label="S" align="center" width="80">
        </el-table-column>
        <el-table-column prop="riskValue" label="R" align="center" width="80">
        </el-table-column>
        <el-table-column prop="riskLevel" label="风险级别" align="center">
          <template slot-scope="scope">
            <div class="risk-level" :style="'background:' + $store.state.select.riskLevel[scope.row.riskLevel].backgroundColor">
              {{ $store.state.select.riskLevel[scope.row.riskLevel].levelNameTwo }}
            </div>
          </template>
        </el-table-column>
        <el-table-column
          prop="measures"
          label="建议新增（改进）措施"
          align="center"
        >
        </el-table-column>
        <el-table-column prop="note" label="备注" align="center">
        </el-table-column>
      </el-table>
    </div>

    <div class="pagination_box">
      <el-pagination
        @current-change="handleCurrentChange"
        :current-page="searchData.pageNum"
        :page-size="searchData.pageSize"
        layout="total, prev, pager, next, jumper"
        :total="total"
      >
      </el-pagination>
    </div>
  </div>
</template>

<script>
export default {
  name: "RiskIdentificationAnalysisLs",
  components: {},
  props: {
    resize: {
      type: Number,
      default: {
        return: 0
      }
    },
    selectValue: {
      type: Number,
      default: {
        return: 0
      }
    }
  },
  data() {
    return {
      // 请求数据
      searchData: {
        schoolId: this.$store.state.schoolId,
        assessType: 0,
        pageNum: 1, // 第几页
        pageSize: 1 // 多少条
      },
      tableData: [],
      total: 0,
      targetRow: []
    };
  },
  watch: {
    resize: function(newVal, oldVal) {
      if (newVal) {
        if (selectValue == 0) {
          this.getList();
        }
      }
    }
  },
  computed: {},
  methods: {
    // 风险管控台账翻页
    handleCurrentChange(val) {
      this.searchData.pageNum = val;
      this.getList();
    },
    // 获取风险管控台账数据
    async getList() {
      let res = await this.$Http.getRiskIdentificationAnalysis(this.searchData);
      if (res.code == 200) {
        this.total = res.data.total || 0;
        this.tableData = res.data.list || [];
        this.getTargetRow();
      } else if (res.code == 101) {
        this.total = 0;
        this.tableData = [];
      } else {
        this.total = 0;
        this.tableData = [];
        this.$message({
          type: "error",
          message: res.messsage
        });
      }
    },
    // 获取检查对象行数
    async getTargetRow() {
      let req = this.searchData;
      let res = await this.$Http.getRiskAutoRow(req);
      if (res.code == 200) {
        this.targetRow = res.data || [];
      } else if (res.code == 101) {
        this.targetRow = [];
      } else {
        this.targetRow = [];
        this.$message({
          type: "error",
          message: res.messsage
        });
      }
    },
    arraySpanMethod({ row, column, rowIndex, columnIndex }) {
      let rid = row.rid;
      if (
        columnIndex == 0 ||
        columnIndex == 1 ||
        columnIndex == 3 ||
        columnIndex == 4 ||
        columnIndex == 5 ||
        columnIndex == 6 ||
        columnIndex == 7 ||
        columnIndex == 8 ||
        columnIndex == 10
      ) {
        if (
          this.getDataValue(rid) == rid &&
          rowIndex == this.getDataInfo(rid).row
        ) {
          return [this.getDataInfo(rid).num, 1];
        } else {
          return {
            rowspan: 0,
            colspan: 0
          };
        }
      } else {
        return {
          rowspan: 1,
          colspan: 1
        };
      }
    },
    getDataInfo(val) {
      let a = this.targetRow.find((item, index) => {
        return item.rid == val;
      });
      if (a) {
        return a;
      }
    },
    getDataValue(val) {
      let a = this.targetRow.find((item, index) => {
        return item.rid == val;
      });
      if (a) {
        return a.rid;
      }
    }
  },
  created() {},
  mounted() {
    this.getList();
  }
};
</script>
<style lang="scss" scoped>
.risk_level_one,
.risk_level_two,
.risk_level_three,
.risk_level_four {
  height: 100%;
  text-align: center;
}
.measure-info {
  width: 100%;
  overflow: hidden;
  text-overflow: ellipsis;
  display: -webkit-box;
  -webkit-line-clamp: 3;
  -webkit-box-orient: vertical;
}
.table_box {
  &.el-table--enable-row-hover {
    background-color: #fff !important;
    /deep/ tbody {
      tr:hover > td {
        background-color: #fff !important;
      }
    }
  }
  /deep/ .el-table__body {
    height: 100%;
    tr > td {
      padding: 0px;
      .cell {
        display: flex;
        justify-content: center;
        align-items: center;
        height: 100%;
        padding: 10px;
        .risk-level {
          margin: -10px;
          width: calc(100% + 20px);
          height: calc(100% + 20px);
          display: flex;
          justify-content: center;
          align-items: center;
        }
        .risk_level_one,
        .risk_level_two,
        .risk_level_three,
        .risk_level_four {
          margin: -10px;
          width: calc(100% + 20px);
          height: calc(100% + 20px);
          display: flex;
          justify-content: center;
          align-items: center;
        }
      }
    }
  }
  tbody {
    tr:hover > td {
      background-color: #fff !important;
    }
  }
}
</style>
